import React, { Component } from "react";
import localStorageService from "./services/localStorageService";
import dashboardRoutes from "./views/dashboard/DashboardRoutes";

let name = "";
let navigation = [];

class navigations {

  // const array = localStorageService.getItem("auth_user").role;
  // for(var i=0; i< array.length;i++){
  //   if(array[i]!==="offline_access" && array[i]!= "uma_authorization"){
  //     name = localStorageService.getItem("auth_user").role[i];
  //   }

  // }


  getlogednUserRoles() {
    navigation = [];
    var menu = [
      {
        role: ['Administrator', 'Officer', 'Applicant', 'Consul', 'Attache', 'CO', 'CA', 'PA'],
        navigation: {
          name: "Dashboard",
          path: "/dashboard/analytics",
          icon: "dashboard",
        },
      },
      {
        role: ['Applicant'],
        navigation: {
          name: "Appointment",
          icon: "insert_drive_file",
          children: [{
            name: "New Appointment",
            path: "/new_application",
            icon: "note_add"
          },
          {
            name: "View Appointment",
            path: "/view_appointment",
            icon: "description"
          },
          ]
        },
      },
      {
        role: ['Applicant'],
        navigation: {
          name: "View Application Status",
          path: "/view_applications",
          icon: "description",
        },
      },
      {
        role: ['Administrator', 'Officer', 'Consul', 'Attache', 'CO', 'CA', 'PA'],
        navigation: {
          name: "Recieved Applications",
          path: "/received_applications",
          icon: "get_app"
        },
      },
      // {
      //   role: ['Administrator', 'Officer'],
      //   navigation: {
      //     name: "Archived Applications",
      //     path: "/archived_applications",
      //     icon: "archive"
      //   },
      // },
      {
        role: ['Administrator', 'Officer', 'Consul', 'Attache', 'CO', 'CA', 'PA'],
        navigation: {
          name: "New Application",
          path: "/new_application_officer",
          icon: "post_add"
        },
      },
      {
        role: ['Administrator', 'Officer', 'Consul', 'Attache', 'CO', 'CA', 'PA'],
        navigation: {
          name: "Update Application",
          path: "/update_application",
          icon: "replay"
        },
      },
      // {
      //   role: ['Administrator', 'Officer', 'Applicant', 'Consul', 'Attache', 'CO', 'CA', 'PA'],
      //   navigation: {
      //     name: "View Posted Applications",
      //     path: "/view_posted_applications",
      //     icon: "markunread_mailbox"
      //   },
      // },
      {
        role: ['Administrator', 'Officer', 'Consul', 'Attache', 'CO', 'CA', 'PA'],
        navigation: {
          name: "Reports",
          icon: "assessment",
          children: [{
            name: "Appointment Reports",
            path: "/appointment_report",
            icon: "assignment"
          },
          {
            name: "Daily Reports",
            path: "/daily_report",
            icon: "today"
          },
          {
            name: "All Reports",
            path: "/all_report",
            icon: "library_books"
          },
          {
            name: "Daily Accounts Reports",
            path: "/daily_account_reports",
            icon: "account_balance"
          },
          {
            name: "Daily Mail Reports",
            path: "/daily_mail_report",
            icon: "mail"
          },
          {
            name: "Daily Counter Reports",
            path: "/daily_counter_report",
            icon: "supervisor_account"
          },
          {
            name: "Reports Sent to D.I.E.",
            path: "/reports_sent_to_die",
            icon: "airplanemode_active"
          },
          {
            name: "Reports Sent to D.M.T.",
            path: "/reports_sent_to_dmt",
            icon: "drive_eta"
          },
          {
            name: "Reports Sent to P.H.Q.",
            path: "/reports_sent_to_phq",
            icon: "security"
          },
          {
            name: "Reports Sent to C.R.R.",
            path: "/reports_sent_to_crt",
            icon: "group_work"
          },
          ]
        },
      },
      {
        role: ['PA'],
        navigation: {
          name: "Data Setup",
          icon: "library_books",
          children: [
            {
          name: "Update Document Type",
          path: "/update_document_type",
          icon: "subject"
        },
        // {
        //   name: "Add New Sub Document Type",
        //   path: "/add_new_sub_document_type",
        //   icon: "playlist_add"
        // },
        {
          name: "Update Sub Document Type",
          path: "/update_sub_document_type",
          icon: "playlist_add_check"
        },
            {
              name: "Create Status Group",
              path: "/create_status_group",
              icon: "border_color"
            },
            {
              name: "Create Status",
              path: "/create_status",
              icon: "create"
            },
            {
              name: "Assign Status",
              path: "/assign_status",
              icon: "assignment_turned_in"
            },
            {
              name: "Update Status",
              path: "/update_status",
              icon: "update"
            },
            {
              name: "Create Amount Type",
              path: "/create_amount_type",
              icon: "attach_money"
            },
            {
              name: "Disable Scheduling Dates",
              path: "/disable_scheduling_dates",
              icon: "event_busy"
            },
          ]
        },
      },
      {
        role: ['Administrator', 'Consul'],
        navigation: {
          name: "User Management",
          path: "/user_management",
          icon: "people_alt"
        },
      },
      {
        role: ['Consul'],
        navigation: {
          name: "Remove Users",
          path: "/remove_users",
          icon: "person_add_disabled"
        },
      },
      // {
      //   role: ['PA'],
      //   navigation: {
      //     name: "Update Emails",
      //     path: "/update_emails",
      //     icon: "mail_outline"
      //   },
      // },
      // {
      //   role: ['PA'],
      //   navigation: {
      //     name: "Update Letters",
      //     path: "/update_letters",
      //     icon: "list_alt"
      //   },
      // },
      {
        role: ['PA'],
        navigation: {
          name: "Revoke Appointments",
          path: "/revoke_appointments",
          icon: "remove_from_queue"
        },
      },
      {
        role: ['Administrator','CO'],
        navigation: {
          name: "Add New User",
          path: "/admin_register",
          icon: "person_add"
        },
      },
    ]

    var roles = [];

    if (localStorageService.getItem("auth_user") !== null) {
      roles = localStorageService.getItem("auth_user").roles;
    }

    if (roles !== undefined) {
      const userpermission = roles.map(roles => roles).flat();
      menu.forEach(menuitem => {
        var count = 0;
        menuitem.role.forEach(menurole => {
          if (userpermission.find(p => p === menurole)) {
            if (count === 0) {
              count++;
              navigation.push(menuitem.navigation)
            }

          }
        })
      })
    }
  }

  // getNavigation() {

  //   this.getlogednUserRoles();

  //   return navigation;
  // }

  getNavigation() {
    let permisions = localStorageService.getItem("auth_user_permisions")
    let roles;
    if (permisions) {
      this.getlogednUserRoles(roles);
    }
    return navigation;
  }


}
export default new navigations();

